import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "Services/Common/errorApiHandleUtils";
import { checkFilter } from "Services/Common/filterUtils";
import { productService } from "Services/Axios/productService";

export const getProduct = createAsyncThunk(
    'product/getProduct',
    async (filters, { rejectWithValue }) => {
        try {
            let filter = checkFilter(filters);
            const response = await productService.getProduct(filter);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const submitProduct = createAsyncThunk(
    'product/submitProduct',
    async (data, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('name', data.name);
            formData.append('description', data.description);
            formData.append('price', data.price);
            formData.append('gimmick_price', data.gimmick_price);
            formData.append('tiktok_url', data.tiktok_url);
            formData.append('shopee_url', data.shopee_url);
            formData.append('tokopedia_url', data.tokopedia_url);
            data.category_id && formData.append('category_id', data.category_id);
            data.photo && formData.append('photo', data.photo);
            data.how_to_use && data.how_to_use.length > 0 && formData.append('how_to_use', `"${JSON.stringify(data.how_to_use).replace(/"/g, '\\"')}"`);

            let response;
            if (data.id) {
                response = await productService.updateProduct(data.id, formData);
            } else {
                response = await productService.createProduct(formData);
            }
            data.successCallback && data.successCallback();
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const deleteProduct = createAsyncThunk(
    'product/deleteProduct',
    async (id, { rejectWithValue }) => {
        try {
            const response = await productService.deleteProduct(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);
